import { AnyAction } from 'redux';
import { EmployeeDTO } from '../../models/dto/EmployeeDTO';
import { authenticationActionTypes } from '../actions/authActions';
import { employeesActionsTypes } from '../actions/employeesActions';

export interface EmployeesReducerData {
  loading: boolean;
  employees: EmployeeDTO[];
  employeeSelected: EmployeeDTO | null;
}

export const ALL_EMPLOYEES: EmployeeDTO = {
  referencia: 0,
  nome: 'Todos',
  numeroCadastro: 0,
  numeroCracha: 0,
  apelido: 'Todos',
  dataNascimento: '',
  dataAdmissao: '',
  cargo: {
    codigo: '0',
    descricao: '',
  },
  salario: 0,
  escala: {
    codigo: 0,
    descricaoJornada: '',
    horas: 0,
    nome: '',
  },
  ocorrencias: [],
  status: '',
  cpf: '',
  pis: '',
};

const INITIAL_STATE = {
  loading: false,
  employees: [],
  employeeSelected: null,
};

export default (
  state: EmployeesReducerData = INITIAL_STATE,
  action: AnyAction,
) => {
  switch (action.type) {
    case employeesActionsTypes.SELECT_EMPLOYEE:
      return {
        ...state,
        employeeSelected: action.payload,
      };

    case employeesActionsTypes.GET_EMPLOYEES:
      return {
        ...state,
        loading: true,
      };

    case employeesActionsTypes.GET_EMPLOYEES_SUCCESS:
      return {
        ...state,
        employees: action.payload,
        loading: false,
      };

    case employeesActionsTypes.GET_EMPLOYEES_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case authenticationActionTypes.LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
};
